import store from '@/store'

const checkPermission = (el, binding) => {
  const { value } = binding
  const permissions = store.getters.userInfo.permission.points

  if (value && value instanceof Array && value.length > 0) {
    const permissionPoints = value
    // 判断当前组件的权限是否在用户的权限点当中
    const hasPermission = permissions.some(permission => {
      return permissionPoints.includes(permission)
    })
    // 如果不存在就将该元素删除
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  } else {
    throw new Error('need permission points! Like v-permission="[\'admin\',\'editor\']"')
  }
}
export default {
  mounted(el, binding) {
    checkPermission(el, binding)
  },
  updated(el, binding) {
    checkPermission(el, binding)
  }
}
